import { render, staticRenderFns } from "./MyGroup.vue?vue&type=template&id=ac6ffe3e&scoped=true"
import script from "./MyGroup.vue?vue&type=script&lang=js"
export * from "./MyGroup.vue?vue&type=script&lang=js"
import style0 from "./MyGroup.vue?vue&type=style&index=0&id=ac6ffe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6ffe3e",
  null
  
)

export default component.exports